/**
 * FairCapsuleCardV2 — RedisignHomePage Capsule card `15:9216`
 * States: Default / Hover · Size Default (560) / Mobile (350)
 */

export const FAIR_CAPSULE_CARD_V2_SIZES = ['default', 'mobile'] as const
export type FairCapsuleCardV2Size = (typeof FAIR_CAPSULE_CARD_V2_SIZES)[number]

export const FAIR_CAPSULE_CARD_V2_STATES = ['default', 'hovered'] as const
export type FairCapsuleCardV2State = (typeof FAIR_CAPSULE_CARD_V2_STATES)[number]

export type FairCapsuleCardV2PreviewState = FairCapsuleCardV2State

export const FAIR_CAPSULE_CARD_V2_ITEM_SLOTS = [
  'outerwear',
  'top',
  'bottom',
  'bag',
  'shoes',
  'accessory-1',
  'accessory-2',
] as const

export type FairCapsuleCardV2ItemSlot =
  (typeof FAIR_CAPSULE_CARD_V2_ITEM_SLOTS)[number]

export interface FairCapsuleCardV2Item {
  id: string
  slot: FairCapsuleCardV2ItemSlot
  imageUrl: string
  alt?: string
  fit?: 'contain' | 'cover'
}

/** One flat-lay outfit inside a capsule carousel slide */
export interface FairCapsuleCardV2Look {
  id: string
  items: FairCapsuleCardV2Item[]
}

export function normalizeFairCapsuleCardV2LookIndex(
  index: number,
  total: number,
): number {
  const safeTotal = Math.max(1, Math.floor(total))
  return Math.min(Math.max(0, Math.floor(index)), safeTotal - 1)
}

/** Desktop hover or mobile always — counter + nav visible */
export function fairCapsuleCardV2ShowsChrome(
  size: FairCapsuleCardV2Size,
  state: FairCapsuleCardV2State,
  totalLooks: number,
): boolean {
  if (totalLooks <= 1) return false
  if (size === 'mobile') return true
  return state === 'hovered'
}

export function fairCapsuleCardV2NavButtonSize(
  size: FairCapsuleCardV2Size,
): 'small' | 'mobile' {
  return size === 'mobile' ? 'mobile' : 'small'
}
